import React from "react";
import T from "prop-types";
import { shortDate } from "LIB/formatters/date";
import { renderIf } from "MODULES/shared/decorators";
import { DetailTable, Detail } from "MODULES/shared/components/DetailTable";
import Section from "MODULES/shared/components/Section";
import { VENDOR_RMA_TYPE } from "MODULES/RMAsAndWarranties/constants";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";

export function VendorRMASection({ rma }) {
  return (
    <React.Fragment>
      <hr className="hr-xs hr-dashed" />
      <Section title="Vendor RMA" editable={false}>
        <DetailTable>
          <Detail label="Date Shipped" value={shortDate(rma.date_shipped)} />
          <Detail label="Returning AWB #" value={rma.outgoing_awb_number} />
          <Detail
            label="Vendor RMA #"
            value={
              <div>
                {rma.vendor_rma_number}{" "}
                {rma.vendor_rma_number_audit && (
                  <AuditedNoteTooltip obj={rma} field="vendor_rma_number" />
                )}
              </div>
            }
          />
        </DetailTable>
      </Section>
    </React.Fragment>
  );
}

VendorRMASection.propTypes = {
  rma: T.shape({
    date_shipped: T.string,
    vendor_rma_number: T.string
  }).isRequired
};

export default renderIf(({ rma }) => rma.type === VENDOR_RMA_TYPE)(
  VendorRMASection
);



// WEBPACK FOOTER //
// ./app/modules/RMAsAndWarranties/components/Detail/Panel/VendorRMASection/VendorRMASection.jsx